<template>
  <div class="container-login">
    <div class="container-dados">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-6 col-lg-5 text-center d-none d-md-block">
            <div class="logo-lecard"><img src="../assets/logo-light.png" alt="Logo LeCard"></div>
          </div>
          <div class="col-md-6 col-lg-5">
            <auth-login-form
              :initial-email="email"
              @authenticated="handleAuthenticated"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container-botton text-white">
      <div class="container pb-3 text-center">
        <p class="m-0 small">© {{ currentYear }} <strong>LeCard</strong>. Todos os direitos reservados.</p>
      </div>
    </div>
  </div>
</template>

<script>
import AuthLoginForm from "@/components/auth/AuthLoginForm";

export default {
  name: 'Login',
  components: {AuthLoginForm},
  data() {
    return {
      email: localStorage.getItem("email") || '',
      currentYear: new Date().getFullYear()
    }
  },

  methods: {
    handleAuthenticated({ data, email }) {
      localStorage.setItem("key", data.token);
      localStorage.setItem("token", data.token);
      localStorage.setItem("email", email);
      window.location.href = '/';
    }
  }
}
</script>

<style scoped>
.container-login {
  background-color: var(--primary);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.container-botton {
  position: absolute;
  width: 100%;
  z-index: 1;
  bottom: 0;
}
.container-dados {
  position: absolute;
  top: 48%;
  transform: translateY(-50%);
  width: 100%;
}
.logo-lecard img {
  width: 300px;
  object-fit: cover;
}

@media (max-width: 767px) {
  .container-dados {
    padding-top: 0;
  }
}

@media (max-height: 550px) {
  .container-login {
    position: static;
  }
  .container-dados {
    position: static;
    transform: none;
    padding: 100px 0 92px;
  }
  .container-botton {
    position: static;
  }
}
</style>
